import React from "react";
import { Alert, Icon } from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setIsSettingsModalVisible, setUserStateData } from "../../store/user/actions";

interface Props {
  user: any;
  setUserStateData: any;
  setIsSettingsModalVisible: (visible: boolean) => void;
}

const DuePaymentAlert = (props: Props): JSX.Element => {
  const { user } = props;
  if (
    user.dataFetched &&
    user.data &&
    user.data.paddle_subscription_status &&
    user.data.paddle_subscription_status == "past_due"
  ) {
    return (
      <div style={{ padding: "0 8px", marginBottom: 8 }}>
        <Alert
          style={{ maxWidth: "100%", padding: 8, borderRadius: 6 }}
          showIcon={false}
          message={
            <div>
              We couldn't charge your bank account. Visit{" "}
              <button
                className="underlined_button"
                onClick={() => {
                  props.setUserStateData({
                    settings: "account__plan",
                  });
                  props.setIsSettingsModalVisible(true);
                }}
              >
                settings
              </button>{" "}
              for details.
            </div>
          }
          type="warning"
        />
      </div>
    );
  } else {
    return null;
  }
};

const mapStateToProps = ({ user }) => {
  return {
    user,
  };
};
export default connect(mapStateToProps, { setUserStateData, setIsSettingsModalVisible })(DuePaymentAlert);
